var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta360(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.782 108.782",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37.109 -210.359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.391,264.75c0,13.468-23.68,24.386-52.891,24.386S38.609,278.218,38.609,264.75c0-7.3,6.949-13.843,17.962-18.312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.535,312.32c-3.635,3.408-7.719,5.321-12.035,5.321-15.187,0-27.5-23.68-27.5-52.891s12.312-52.891,27.5-52.891c7.372,0,14.066,5.579,19,14.662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.344,256.069h8.681v8.681H73.344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.344,264.75h8.681v8.681H73.344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.841,264.75H87.159v-8.681h8.681"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.681,
    height: 8.681,
    x: 87.159,
    y: 264.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.656,264.75v8.681h-8.681V256.069h8.681Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.107,
    cy: 258.927,
    r: 2.858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.662,244.042l6.909,2.4-2.4,6.909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.166,219.4l-1.662,7.121-7.121-1.662"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta360);
export default __webpack_public_path__ + "static/media/insta360.eb02b0b743bbc7ba8fd82370d88f35f6.svg";
export { ForwardRef as ReactComponent };